import { render, staticRenderFns } from "./selectedChild.vue?vue&type=template&id=5c76b33c&scoped=true"
import script from "./selectedChild.vue?vue&type=script&lang=js"
export * from "./selectedChild.vue?vue&type=script&lang=js"
import style0 from "./selectedChild.vue?vue&type=style&index=0&id=5c76b33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76b33c",
  null
  
)

export default component.exports